module.exports = __webpack_public_path__ + "img/LUB00038.ac42eb9f.png";